/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';
import {
  getSafeLocalStorageItem,
  removeSafeLocalStorageItem,
  setSafeLocalStorageItem,
} from './safeLocalStorage';

export const toggleV6Auth = () => {
  if (Platform.OS === 'web') {
    const current = getSafeLocalStorageItem('showV6Auth');
    if (current) {
      removeSafeLocalStorageItem('showV6Auth');
    } else {
      setSafeLocalStorageItem('showV6Auth', 'true');
    }
    window.location.reload();
  }
};

export const shouldShowDevAuthToggle = (env: string) => {
  return Platform.OS === 'web' && ((env as string) === 'dev' || env === 'stg');
};
